import { formatInTimeZone } from 'date-fns-tz';

import type { UnwrapData } from '@/api/types';
import { DATE_FORMATTERS, ENVS, TIME_ZONE } from '@/shared/consts';

import { teachbaseService } from '../../services/teachbaseService';

import type { ICreateQuizResponse, IGenerateAuthLinkResponse, ITeachbaseAuthDataResponse } from './types';

export const teachbaseApiService = teachbaseService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить авторизационные данные от Teachbase
     */
    getTeachbaseAuthData: builder.mutation<ITeachbaseAuthDataResponse, void>({
      query: () => ({
        method: 'POST',
        url: `${ENVS.LMS_URL}/community/auth/signin`,
      }),
    }),
    /**
     * Создать квиз в LMS
     */
    createTeachbaseQuiz: builder.mutation<UnwrapData<ICreateQuizResponse>, { LMSAccountId: number }>({
      query: ({ LMSAccountId }) => ({
        method: 'POST',
        url: `/edu_launcher/managers/courses`,
        body: {
          name: `Новый тест (${formatInTimeZone(new Date(), TIME_ZONE.MOSCOW, DATE_FORMATTERS.DAY_MONTH_FULL_YEAR_HOURS_MINUTES_SECONDS)})`,
          content_type: 'quiz',
        },
        headers: {
          'X-Account-Id': LMSAccountId,
        },
        redirect: 'manual',
      }),
      transformResponse: (response: ICreateQuizResponse) => response.data,
    }),
    /**
     * Создаёт ссылку с токеном авторизации для перехода по переданному URL
     */
    generateTeachbaseAuthLink: builder.mutation<
      IGenerateAuthLinkResponse,
      { redirectURL: string; LMSAccountId: number }
    >({
      query: ({ redirectURL, LMSAccountId }) => ({
        method: 'POST',
        url: `${ENVS.LMS_URL}/digital_education/api/auth_links`,
        body: {
          redirect_url: redirectURL,
        },
        headers: {
          'X-Account-Id': LMSAccountId,
        },
      }),
    }),
  }),
});

export const { useGetTeachbaseAuthDataMutation, useCreateTeachbaseQuizMutation, useGenerateTeachbaseAuthLinkMutation } =
  teachbaseApiService;
